(function () {

  'use strict';

  function pxWorkflowMetadata($rootScope, uuid, MetadataCustomFieldType, MetadataCustomFieldValidationType, RegexModel) {
    return {
      restrict: 'E',
      scope: {
        me: '=',
        tenant: '=',
        workflowForm: '=',
        workflowFormModel: '=',
        fileNameShorthands: '='
      },
      templateUrl: 'app/components/settings/workflows/workflowProperties/metadata/workflowMetadata.template.html',
      link: function (scope, element, attrs) {

        const regexModel = new RegexModel();
        const urlRegExp = regexModel.urlRegex();
        const emailRegExp = regexModel.emailRegex();
        const integerRegExp = /^[+-]?\d+$/;
        const containsVariableReferenceRegExp = /\{.+?\}/;

        const dateFormatRegExps = {
          'dd-MM-yyyy': /^(?:0[1-9]|[12][0-9]|3[01])-(?:0[1-9]|1[0-2])-\d{4}$/,
          'MM-dd-yyyy': /^(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])-\d{4}$/,
          'yyyy-MM-dd': /^\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$/
        };

        let customRegExp;

        scope.nameRegExp = /^[a-zA-Z_][a-zA-Z0-9_]*$/;
        scope.nameMaxLength = 50;
        scope.labelMaxLength = 50;
        scope.regularExpressionMaxLength = 200;
        scope.defaultValueMaxLength = 200;
        scope.emptyString = '';

        scope.availableItemsDialogOpen = -1;

        scope.typeOptions = [
          { value: MetadataCustomFieldType.Text, label: 'Text' },
          { value: MetadataCustomFieldType.Lookup, label: 'Lookup' }
        ];

        scope.validationTypeOptions = [
          { value: '', label: 'PlainText' },
          { value: MetadataCustomFieldValidationType.Numeric, label: 'Number' },
          { value: MetadataCustomFieldValidationType.Url, label: 'Url' },
          { value: MetadataCustomFieldValidationType.Email, label: 'Email' },
          { value: MetadataCustomFieldType.Date, label: 'Date' },
          { value: MetadataCustomFieldValidationType.Regex, label: 'Custom' }
        ];

        scope.dateFormatOptions = [
          { value: 'dd-MM-yyyy', label: 'DD_MM_YYYY' },
          { value: 'MM-dd-yyyy', label: 'MM_DD_YYYY' },
          { value: 'yyyy-MM-dd', label: 'YYYY_MM_DD' }
        ];

        scope.numberOfDecimalsOptions = [
          { value: 0, label: '0' },
          { value: 1, label: '1' },
          { value: 2, label: '2' },
          { value: 3, label: '3' },
          { value: 4, label: '4' }
        ];

        scope.isAddButtonDisabled = function () {
          return scope.workflowFormModel.metadataProfile.metadataFields.length >= 10;
        };

        scope.addMetadataField = function () {
          if (scope.workflowFormModel.metadataProfile.metadataFields.length < 10) {
            scope.workflowFormModel.metadataProfile.metadataFields.push({
              id: uuid.v4(),
              name: '',
              label: '',
              required: false,
              type: scope.typeOptions[0].value,
              validationType: scope.validationTypeOptions[0].value,
              regularExpression: '',
              dateFormat: scope.dateFormatOptions[0].value,
              decimals: scope.numberOfDecimalsOptions[0].value,
              defaultValue: '',
              dataSource: undefined,
              availableValues: [],
              isNew: true
            });
          }
        };

        scope.removeMetadataField = function (metadataField) {
          const index = scope.workflowFormModel.metadataProfile.metadataFields.indexOf(metadataField);
          if (index !== -1) {
            scope.workflowFormModel.metadataProfile.metadataFields.splice(index, 1);
            if (metadataField.dataSource?.id) {
              scope.workflowFormModel.metadataProfile.dataSourceIdsToRemove.push(metadataField.dataSource.id);
            }
            if (metadataField.name) {
              $rootScope.$broadcast('METADATA_DELETED', metadataField.name);
            }
          }
        };

        scope.onNameChange = function (metadataField) {
          if (metadataField.name) {
            if (metadataField.oldName && metadataField.oldName !== metadataField.name) {
              $rootScope.$broadcast('METADATA_RENAMED', metadataField.oldName, metadataField.name);
            }
            metadataField.oldName = metadataField.name;
          }
        };

        scope.onValidationTypeChange = function (metadataField) {
          if (metadataField.validationType === MetadataCustomFieldType.Date) {
            if (!metadataField.dateFormat) {
              metadataField.dateFormat = scope.dateFormatOptions[0].value;
            }
          } else if (metadataField.validationType === MetadataCustomFieldValidationType.Numeric) {
            if (!metadataField.decimals) {
              metadataField.decimals = scope.numberOfDecimalsOptions[0].value;
            }
          }
        };

        scope.onRegularExpressionChange = function (metadataField) {
          customRegExp = metadataField.regularExpression ? new RegExp(metadataField.regularExpression) : undefined;
        };

        scope.getDefaultValueRegExp = function (metadataField) {
          if (metadataField.validationType !== MetadataCustomFieldValidationType.Numeric && metadataField.validationType !== MetadataCustomFieldType.Date &&
            metadataField.defaultValue?.length && containsVariableReference(metadataField.defaultValue)) {
            return undefined;
          }
          switch (metadataField.validationType) {
            case MetadataCustomFieldValidationType.Numeric:
              return integerRegExp;
            case MetadataCustomFieldValidationType.Url:
              return urlRegExp;
            case MetadataCustomFieldValidationType.Email:
              return emailRegExp;
            case MetadataCustomFieldValidationType.Regex:
              return customRegExp;
            case MetadataCustomFieldType.Date:
              return dateFormatRegExps[metadataField.dateFormat];
            default:
              return undefined;
          }
        };

        scope.getDefaultValueMaxLength = function (metadataField) {
          if (metadataField.validationType !== MetadataCustomFieldValidationType.Numeric && metadataField.validationType !== MetadataCustomFieldType.Date &&
            metadataField.defaultValue?.length && containsVariableReference(metadataField.defaultValue)) {
            return undefined;
          }
          return scope.defaultValueMaxLength;
        };

        scope.getVariables = function (metadataField) {
          if (metadataField.type === 'TEXT' && metadataField.validationType !== 'NUMERIC' && metadataField.validationType !== 'DATE') {
            return scope.fileNameShorthands.FILE_NAME_CONTEXT;
          }
          return undefined;
        };

        scope.getDates = function (metadataField) {
          if (metadataField.type === 'TEXT' && metadataField.validationType !== 'NUMERIC' && metadataField.validationType !== 'DATE') {
            return scope.fileNameShorthands.DATE;
          }
          return undefined;
        };

        function containsVariableReference(value) {
          return containsVariableReferenceRegExp.test(value);
        }

        scope.openAvailableItemsDialog = function (index) {
          scope.availableItemsDialogOpen = index;
        };

        scope.closeAvailableItemsDialog = function () {
          scope.availableItemsDialogOpen = -1;
        };

        scope.onAvailableItemsDialogOk = function () {
          scope.closeAvailableItemsDialog();
        };

        scope.onAvailableItemsDialogCancel = function () {
          scope.closeAvailableItemsDialog();
        };
      }
    };
  }

  pxWorkflowMetadata.$inject = ['$rootScope', 'uuid', 'MetadataCustomFieldType', 'MetadataCustomFieldValidationType', 'RegexModel'];

  angular
    .module('printix-admin')

    .factory('DataSource', function (DataSourceColumn, DataSourceRequest) {
      return function (id, displayName, columns, records) {

        this.id = id;                   // string
        this.displayName = displayName; // string
        this.columns = columns;         // array of DataSourceColumn objects
        this.records = records;         // array of arrays of strings

        this.toDataSourceRequest = function () {
          const columns = this.columns.map(column => column.toDataSourceColumnRequest());
          const records = angular.copy(this.records);
          return new DataSourceRequest(this.displayName, columns, records);
        };

        this.fromDataSourceResponse = function (dataSourceResponse) {
          this.id = dataSourceResponse.id;
          this.displayName = dataSourceResponse.displayName;
          this.columns = dataSourceResponse._embedded.columns.map(column => new DataSourceColumn().fromDataSourceColumnResponse(column));
          return this;
        };

        return this;
      };
    })

    .factory('DataSourceColumn', function (DataSourceColumnRequest) {
      return function (id, name, displayName, visible, metadata, sortIndex, sortDirection) {

        this.id = id;                       // integer
        this.name = name;                   // string
        this.displayName = displayName;     // string
        this.visible = visible;             // boolean
        this.metadata = metadata;           // boolean
        this.sortIndex = sortIndex;         // integer
        this.sortDirection = sortDirection; // string (property of SortDirection)

        this.toDataSourceColumnRequest = function () {
          return new DataSourceColumnRequest(this.id, this.name, this.displayName, this.visible, this.metadata, this.sortIndex, this.sortDirection);
        };

        this.fromDataSourceColumnResponse = function (dataSourceColumnResponse) {
          this.id = dataSourceColumnResponse.id;
          this.name = dataSourceColumnResponse.name;
          this.displayName = dataSourceColumnResponse.displayName;
          this.visible = dataSourceColumnResponse.visible;
          this.metadata = dataSourceColumnResponse.metadata;
          this.sortIndex = dataSourceColumnResponse.sortIndex;
          this.sortDirection = dataSourceColumnResponse.sortDirection;
          return this;
        };

        return this;
      };
    })

    .factory('DataSourceRecord', function () {
      return function (id, data) {

        this.id = id;                 // string
        this.key = data && data[0];   // string
        this.value = data && data[1]; // string

        this.fromDataSourceRecordResponse = function (dataSourceRecordResponse) {
          this.id = dataSourceRecordResponse.id;
          this.key = dataSourceRecordResponse.data[0];
          this.value = dataSourceRecordResponse.data[1];
          return this;
        };

        return this;
      };
    })

    .directive('pxWorkflowMetadata', pxWorkflowMetadata);

})();
